// extracted by mini-css-extract-plugin
export var container = "_an-0";
export var containerTopRight = "_an-1";